import React from "react";
import { Link } from "react-router-dom";

const Chevron = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    className="w-3 h-3 sm:w-5 sm:h-5 text-gray-400 flex-shrink-0"
    aria-hidden="true"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const FeedTop = () => {
  // Compact on mobile (fits at 360px); larger framed thumbnail + depth on desktop.
  // h-full so both tiles fill the grid row — on the narrowest phones the League
  // Play subtitle still wraps to two lines, and this keeps the Leaderboard tile
  // the same height beside it.
  //
  // MOBILE SPACING IS DELIBERATELY TIGHT. The binding constraint is the League
  // Play subtitle: "Skilled competitions" needs ~114px on one line at 12px, and
  // the text column only gets what is left after the thumbnail, the two gaps,
  // the chevron and the card's own padding. Every px trimmed here goes straight
  // into that column, so treat these values as load-bearing rather than taste.
  // The sm: values are the untouched desktop design.
  const cardClass =
    "feed-shadow flex items-center gap-1.5 sm:gap-4 h-full bg-white border border-gray-100 rounded-2xl px-1 py-2.5 sm:px-5 sm:py-8 hover:shadow-sm transition-shadow";
  const thumbClass =
    "flex items-center justify-center flex-shrink-0 w-8 h-8 sm:w-20 sm:h-20";
  const imgClass = "object-contain w-8 h-8 sm:w-full sm:h-full";

  return (

      <div className="grid grid-cols-2 sm:gap-6 gap-2 w-full">
        <div className="sm:p-4 flex-1 sm:-mx-4">
          <Link to="/leaderboard" id="feed-guide-leaderboard" className={cardClass}>
            <span className={thumbClass}>
              <img
                src={`${process.env.PUBLIC_URL}/leaderboard.png`}
                alt="Leaderboard"
                className={imgClass}
              />
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-[14px] sm:text-xl font-bold text-gray-900 leading-tight whitespace-nowrap">
                Leaderboard
              </p>
              <p className="text-[12px] sm:text-sm text-gray-500 leading-tight whitespace-nowrap">
                Top Traders
              </p>
            </div>
            <Chevron />
          </Link>
        </div>
        <div className="sm:p-4 flex-1 sm:-mx-4">
          <Link to="/contest" id="feed-guide-league-play" className={cardClass}>
            <span className={thumbClass}>
              <img
                src={`${process.env.PUBLIC_URL}/league_play.png`}
                alt="League Play"
                className={imgClass}
              />
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-[14px] sm:text-xl font-bold text-gray-900 leading-tight whitespace-nowrap">
                League Play
              </p>
              {/* Client asked for different wording per breakpoint: "Skilled
                  competitions" on mobile, "Skill-based competitions" on
                  desktop.

                  The client then asked for the mobile line to sit on ONE line
                  without shrinking the type. tracking-tight is the only lever
                  applied to the text itself — it tightens letter-spacing, not
                  font size, and buys ~6px. The rest of the room comes from the
                  spacing above. Desktop keeps normal tracking.

                  The nowrap stays scoped to sm+ on purpose: below ~390px the
                  line still cannot fit, and wrapping to two lines is a better
                  failure than overflowing past the chevron. */}
              <p className="text-[12px] sm:text-sm text-gray-500 leading-tight tracking-tight sm:tracking-normal sm:whitespace-nowrap">
                <span className="sm:hidden">Skilled competitions</span>
                <span className="hidden sm:inline">Skill-based competitions</span>
              </p>
            </div>
            <Chevron />
          </Link>
        </div>
      </div>

  );
};

export default FeedTop;
